import React from 'react';
import '../styles/brochure.css';
import { Shield, TrendingUp, Users, CheckCircle, FileText, Settings, Target, Mail, Globe } from 'lucide-react';

const Brochure = () => {
  return (
    <div className="brochure-container">
      {/* Page 1 - Left Side */}
      <div className="brochure-page page-left">
        {/* Header avec logo */}
        <div className="brochure-header">
          <div className="logo-section">
            <img src="/assets/secura-logo.png" alt="SECURA CONSULTING" className="brochure-logo" />
          </div>
        </div>

        {/* Hero Section */}
        <div className="hero-section">
          <div className="hero-content">
            <h1 className="hero-title">
              VOTRE CONFORMITÉ <span className="text-blue">NIS2,</span><br/>
              NOTRE MISSION
            </h1>
            <p className="hero-subtitle">Opérateur de conformité NIS2<br/>pour PME & ETI</p>
            <p className="hero-description">
              SECURA CONSULTING externalise votre gouvernance cyber et votre conformité réglementaire pour faire de la cybersécurité un levier de confiance et de performance.
            </p>
          </div>
          <div className="hero-image">
            <div className="shield-icon-large">
              <Shield size={120} />
            </div>
          </div>
        </div>

        {/* Trois valeurs */}
        <div className="values-section">
          <div className="value-card">
            <div className="value-icon">
              <CheckCircle size={48} />
            </div>
            <h3 className="value-title">CONFORMITÉ</h3>
            <p className="value-text">
              Nous rendons votre entreprise conforme à la directive NIS2 et audit-ready.
            </p>
          </div>

          <div className="value-card">
            <div className="value-icon">
              <TrendingUp size={48} />
            </div>
            <h3 className="value-title">RÉSILIENCE</h3>
            <p className="value-text">
              Nous structurons votre cybersécurité pour protéger l'essentiel.
            </p>
          </div>

          <div className="value-card">
            <div className="value-icon">
              <Users size={48} />
            </div>
            <h3 className="value-title">CONFIANCE</h3>
            <p className="value-text">
              Nous renforçons votre crédibilité auprès de vos clients, partenaires et régulateurs.
            </p>
          </div>
        </div>

        {/* NIS2 Opportunité */}
        <div className="opportunity-section">
          <h2 className="section-title">
            NIS2 : UNE EXIGENCE, <span className="text-blue">UNE OPPORTUNITÉ</span>
          </h2>
          <div className="opportunity-content">
            <div className="opportunity-text">
              <p>
                La directive européenne NIS2 impose aux entreprises des secteurs essentiels et importants de renforcer leur cybersécurité, leur gouvernance et leur capacité à gérer les incidents.
              </p>
              <p className="highlight-text">
                SECURA CONSULTING vous aide à transformer cette obligation en avantage compétitif.
              </p>
            </div>
            <div className="opportunity-image">
              <div className="checklist-icon">
                <FileText size={80} />
              </div>
            </div>
          </div>
        </div>

        {/* Qui sommes-nous */}
        <div className="about-section">
          <h2 className="section-title">QUI SOMMES-NOUS ?</h2>
          <p className="about-text">
            <strong>SECURA CONSULTING</strong> est un opérateur de conformité spécialisé NIS2.
          </p>
          <p className="about-text">
            Nous n'intégrons pas de solutions techniques et ne vendons pas d'outils : nous pilotons votre conformité de bout en bout.
          </p>
          <p className="mission-text">
            Notre mission : rendre votre entreprise conforme, résiliente et pilotable, tout en vous préparant aux contrôles et audits.
          </p>
        </div>

        {/* Stats */}
        <div className="stats-section">
          <div className="stat-item">
            <div className="stat-icon">
              <Users size={40} />
            </div>
            <p className="stat-label">PME & ETI<br/>accompagnées</p>
          </div>
          <div className="stat-item">
            <div className="stat-icon">
              <Target size={40} />
            </div>
            <p className="stat-label">100%<br/>dédié NIS2</p>
          </div>
          <div className="stat-item">
            <div className="stat-icon">
              <Settings size={40} />
            </div>
            <p className="stat-label">Approche métier,<br/>opérationnelle<br/>et sur-mesure</p>
          </div>
        </div>

        {/* Footer Page 1 */}
        <div className="page-footer">
          <div className="footer-logo">
            <strong>SECURA CONSULTING</strong>
          </div>
          <div className="footer-contact">
            <p>www.securaconsulting.fr</p>
            <p>contact@secura-consulting.fr</p>
          </div>
        </div>
      </div>

      {/* Page 2 - Right Side */}
      <div className="brochure-page page-right">
        {/* Approche Opérationnelle */}
        <div className="approach-section">
          <h2 className="section-title-white">
            NOTRE APPROCHE <span className="text-blue-light">OPÉRATIONNELLE</span>
          </h2>
          <p className="approach-intro">
            Nous intégrons les exigences NIS2 dans votre organisation, vos processus et vos outils existants, sans disruption inutile.
          </p>

          <div className="steps-container">
            <div className="step-item">
              <div className="step-number">1</div>
              <div className="step-content">
                <h4 className="step-title">DIAGNOSTIQUER</h4>
                <p className="step-text">Évaluation de votre niveau de conformité et de maturité cyber</p>
              </div>
            </div>

            <div className="step-item">
              <div className="step-number">2</div>
              <div className="step-content">
                <h4 className="step-title">PLANIFIER</h4>
                <p className="step-text">Feuille de route NIS2 priorisée et adaptée à votre contexte</p>
              </div>
            </div>

            <div className="step-item">
              <div className="step-number">3</div>
              <div className="step-content">
                <h4 className="step-title">METTRE EN ŒUVRE</h4>
                <p className="step-text">Mise en place de votre politique, processus et gouvernance requis</p>
              </div>
            </div>

            <div className="step-item">
              <div className="step-number">4</div>
              <div className="step-content">
                <h4 className="step-title">PILOTER</h4>
                <p className="step-text">Suivi des indicateurs, gestion des risques et amélioration continue</p>
              </div>
            </div>

            <div className="step-item">
              <div className="step-number">5</div>
              <div className="step-content">
                <h4 className="step-title">PRÉPARER AUX AUDITS</h4>
                <p className="step-text">Documentation, preuves et restitution pour être audit-ready</p>
              </div>
            </div>
          </div>
        </div>

        {/* Offres */}
        <div className="offers-section">
          <h2 className="section-title">
            NOS OFFRES <span className="text-blue">SUR-MESURE</span>
          </h2>
          <p className="offers-intro">Trois niveaux d'accompagnement pour répondre à vos besoins.</p>

          <div className="offers-grid">
            <div className="offer-card">
              <div className="offer-header">
                <Shield size={40} className="offer-icon" />
                <h3 className="offer-title">START</h3>
                <p className="offer-subtitle">Sécuriser l'essentiel</p>
              </div>
              <ul className="offer-list">
                <li>• Diagnostic NIS2</li>
                <li>• Plan d'actions priorisé</li>
                <li>• Sensibilisation des équipes</li>
              </ul>
              <p className="offer-footer">Idéal pour démarrer votre démarche.</p>
            </div>

            <div className="offer-card offer-recommended">
              <div className="recommended-badge">⭐ Recommandé</div>
              <div className="offer-header">
                <Target size={40} className="offer-icon" />
                <h3 className="offer-title">BUILD</h3>
                <p className="offer-subtitle">Structurer et se mettre<br/>en conformité</p>
              </div>
              <ul className="offer-list">
                <li>• Mise en place de la gouvernance</li>
                <li>• Politiques et processus clés</li>
                <li>• Gestion des risques et des incidents</li>
              </ul>
              <p className="offer-footer">Pour avancer concrètement vers la conformité.</p>
            </div>

            <div className="offer-card">
              <div className="offer-header">
                <TrendingUp size={40} className="offer-icon" />
                <h3 className="offer-title">RUN</h3>
                <p className="offer-subtitle">Piloter et progresser<br/>dans la durée</p>
              </div>
              <ul className="offer-list">
                <li>• Externalisation de la fonction conformité NIS2</li>
                <li>• Pilotage mensuel</li>
                <li>• Préparation aux audits</li>
              </ul>
              <p className="offer-footer">Pour rester conforme et garder une longueur d'avance.</p>
            </div>
          </div>
        </div>

        {/* Pourquoi choisir */}
        <div className="why-section">
          <h2 className="section-title">
            POURQUOI CHOISIR <span className="text-blue">SECURA CONSULTING ?</span>
          </h2>

          <div className="why-grid">
            <div className="why-item">
              <Users size={40} className="why-icon" />
              <h4 className="why-title">EXPERTISE NIS2</h4>
              <p className="why-text">100% dédiée à la conformité et à la gouvernance cyber</p>
            </div>

            <div className="why-item">
              <Shield size={40} className="why-icon" />
              <h4 className="why-title">APPROCHE OPÉRATIONNELLE</h4>
              <p className="why-text">Des livrables concrets et actionnables</p>
            </div>

            <div className="why-item">
              <CheckCircle size={40} className="why-icon" />
              <h4 className="why-title">INDÉPENDANCE</h4>
              <p className="why-text">Aucune vente d'outils, aucun conflit d'intérêt</p>
            </div>

            <div className="why-item">
              <TrendingUp size={40} className="why-icon" />
              <h4 className="why-title">IMPACT BUSINESS</h4>
              <p className="why-text">Une cybersécurité au service de votre performance</p>
            </div>
          </div>
        </div>

        {/* Ils nous font confiance */}
        <div className="trust-section">
          <h2 className="section-title">ILS NOUS FONT CONFIANCE</h2>
          <p className="trust-text">
            PME et ETI de secteurs critiques et importants nous font confiance pour sécuriser leur activité et répondre aux exigences NIS2.
          </p>
          <p className="trust-question">Pourquoi pas vous ?</p>

          <div className="sectors-grid">
            <div className="sector-item">INDUSTRIE</div>
            <div className="sector-item">SERVICES ESSENTIELS</div>
            <div className="sector-item">SANTÉ</div>
            <div className="sector-item">TRANSPORT</div>
          </div>
        </div>

        {/* CTA */}
        <div className="cta-section">
          <h2 className="cta-title">PRÊT À PASSER À L'ACTION ?</h2>
          <p className="cta-text">
            Échangeons sur vos enjeux et construisons ensemble votre feuille de route NIS2.
          </p>
          <div className="cta-contact">
            <div className="contact-item">
              <Globe size={24} />
              <span>www.securaconsulting.fr</span>
            </div>
            <div className="contact-item">
              <Mail size={24} />
              <span>contact@secura-consulting.fr</span>
            </div>
          </div>
        </div>

        {/* Footer Page 2 */}
        <div className="page-footer-blue">
          <div className="footer-content">
            <div className="footer-tagline">
              <p><strong>SECURA CONSULTING</strong></p>
              <p><strong>Votre conformité NIS2, notre mission.</strong></p>
              <p>Votre résilience, notre engagement.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Print Button */}
      <div className="print-button-container no-print">
        <button onClick={() => window.print()} className="print-button">
          📄 Télécharger en PDF
        </button>
      </div>
    </div>
  );
};

export default Brochure;
